import { CountriesResponse } from '@api/api/financial-events/countries';
import { financialEvents } from '@api/api/financial-events/financial-events';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_FINANCIAL_EVENTS_COUNTRIES =
  'QUERY_KEY_FINANCIAL_EVENTS_COUNTRIES';

export const useFinancialEventsCountries = () =>
  useQuery({
    queryKey: [QUERY_KEY_FINANCIAL_EVENTS_COUNTRIES],
    queryFn: ({ signal }) => {
      const { path, schema } = financialEvents.getCountries;
      return wretchRequest<CountriesResponse>(path, {
        schema,
        signal,
      });
    },
    staleTime: getTimeTillEndOfDayMs(),
    select: data =>
      data.countries
        .filter(c => !!c.code)
        .sort((a, b) => a.name.localeCompare(b.name)),
  });
